import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const SendBulkEmail = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default SendBulkEmail;
